import { render, staticRenderFns } from "./ConfirmDepositDialog.vue?vue&type=template&id=2ae657ca&scoped=true"
import script from "./ConfirmDepositDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDepositDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDepositDialog.vue?vue&type=style&index=0&id=2ae657ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae657ca",
  null
  
)

export default component.exports